exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "#errorMessage {\n    padding-top: 15px;\n}\n\ninput {\n    background: white;\n    font-size: 16px;\n    -webkit-appearance: none;\n    color: black;\n}\n\n#subscribe {\n    margin: auto;\n    text-align: center;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/structural_components/footer/subscribe/subscribe.component.css
// module id = 383
// module chunks = 1